var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-section',{staticClass:"p-program__inner",class:{'extra-padding': _vm.page.inscriptionRunning}},[(_vm.page.sections && _vm.page.sections.length)?_c('app-builder',{attrs:{"sections":_vm.page.sections}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }